import {
  CircularProgress,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import React, { Fragment } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { selectUser } from "../../../features/data/user/userSlice";

const useStyles = makeStyles(() => ({
  paper: {
    marginRight: 10,
    marginBottom: 10,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
  },
  lastPaper: {
    marginBottom: 10,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
  },
  nameTypo: {
    fontSize: "15px",
    // color: "#757575",
  },
  valueTypo: {
    fontSize: "25px",
    // color: "#000000",
    fontWeight: "bold",
  },
  progress: {
    color: "#757575",
  },
}));

const Summary = (props) => {
  const { loading, summary } = props;
  const classes = useStyles();
  const { user } = useSelector(selectUser, shallowEqual);

  return (
    <Fragment>
      <Grid item xs={12} md={user.role === "admin" ? 4 : 12}>
        <Paper className={classes.paper}>
          {loading ? (
            <CircularProgress className={classes.progress} />
          ) : (
            <Typography className={classes.valueTypo}>
              {summary?.myValuationsCount?.toString().toPersianDigits()}
            </Typography>
          )}
          <Typography className={classes.nameTypo}>ارزیابی های من</Typography>
        </Paper>
      </Grid>

      {user.role === "admin" && (
        <>
          <Grid item xs={12} md={4}>
            <Paper className={classes.paper}>
              {loading ? (
                <CircularProgress className={classes.progress} />
              ) : (
                <Typography className={classes.valueTypo}>
                  {summary?.allValuationsCount?.toString().toPersianDigits()}
                </Typography>
              )}
              <Typography className={classes.nameTypo}>
                کل ارزیابی های سایت
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper className={classes.lastPaper}>
              {loading ? (
                <CircularProgress className={classes.progress} />
              ) : (
                <Typography className={classes.valueTypo}>
                  {summary?.activeUsersCount?.toString().toPersianDigits()}
                </Typography>
              )}
              <Typography className={classes.nameTypo}>کاربران سایت</Typography>
            </Paper>
          </Grid>
        </>
      )}
    </Fragment>
  );
};

export default Summary;
